export enum SortOrder {
  Alphabetical = 'alphabetical',
  LatestAlarm = 'latest',
  Unopened = 'unopened',
  Criticality = 'criticality',
  Kilometer = 'kilometer',
}
